module.exports = __webpack_public_path__ + "img/24.ca215b28.jpg";